export default {
  roof: [],
  projectDetails: {
    customerName: null,
    projectName: null,
    address: null,
    number: null,
    jobType: 'none',
    buildingType: 'none',
    roofType: 'none',
  },
  hourlyWage: {
    wage: 0,
    vacationMoney: 0,
    pensionCost: 0,
    employerTax: 0,
    hourlyCost: 0,
    travelCost: 0,
    summaryCost: 0,
    unproductivePercentage: 0,
    unproductiveCost: 0,
    totalCompanyCost: 0,
  },
  roofMaterialCost: {
    totalExVat: 0,
    vatAmount: 0,
    totalIncVat: 0,
  },
  requiredHours: {
    totalRequiredHours: 0,
  },
  icopalProductList: {
    totalCost: 0,
  },
  nonIcopalProductList: {
    products: [],
    totalCost: 0,
  },
};
